export default __webpack_public_path__ + "static/media/AshokaMinionParticleImpact.3d382f7a.png";